import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import {
  Confirmation,
  ContactUs,
  Dashboard,
  Donations,
  Login,
  Messages,
  MobileCheckDeposit,
  MobileCheckDepositProvider,
  NotRegistered,
  RecoverIdentity,
  Registration,
  Resources,
  Team,
} from './screens';
import { Layout, PrivateRoute } from './components';
import { useAnalytics } from './analytics';
import { useTeamsAllowed } from './hooks';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const App: FC = () => {
  // This updates the datalayer for analytics
  useAnalytics();

  const teamsExist = useTeamsAllowed();

  return (
    <Layout>
      <SentryRoutes>
        <Route path="/login" element={<Login />} />
        <Route path="/login/not-registered" element={<NotRegistered />} />
        <Route path="/recover" element={<RecoverIdentity />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/donations"
          element={
            <PrivateRoute>
              <Donations />
            </PrivateRoute>
          }
        />
        <Route
          path="/messages"
          element={
            <PrivateRoute>
              <Messages />
            </PrivateRoute>
          }
        />
        {teamsExist && (
          <Route
            path="/team"
            element={
              <PrivateRoute>
                <Team />
              </PrivateRoute>
            }
          />
        )}
        <Route
          path="/registration"
          element={
            <PrivateRoute>
              <Registration />
            </PrivateRoute>
          }
        />
        <Route
          path="/resources"
          element={
            <PrivateRoute>
              <Resources />
            </PrivateRoute>
          }
        />
        <Route
          path="/check-deposit"
          element={
            <PrivateRoute>
              <MobileCheckDepositProvider>
                <MobileCheckDeposit />
              </MobileCheckDepositProvider>
            </PrivateRoute>
          }
        />
        <Route
          path="/confirmation"
          element={
            <PrivateRoute>
              <Confirmation />
            </PrivateRoute>
          }
        />
        <Route
          path="/contactus"
          element={
            <PrivateRoute>
              <ContactUs />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </SentryRoutes>
    </Layout>
  );
};
